import React, { useEffect } from "react";
import { useMyContext } from "src/hooks/context";
import * as API from "src/api/request";

import Info from "src/components/home/info";
import Detail from "src/components/home/detail";

const Home = () => {
	const { state, dispatch, type } = useMyContext();

	useEffect(() => {
		dispatch({ type: type.CHANGE_LOADING, data: true });
		API.getList()
			.then((res) => {
				dispatch({
					type: type.CHANGE_LIST_MONTH,
					data: res,
				});
			})
			.catch(() => dispatch({ type: type.CHANGE_LIST_MONTH, data: [] }));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (state.selectedMonth !== null) {
			dispatch({ type: type.CHANGE_LOADING, data: true });
			API.getDetail(
				state.selectedMonth.year,
				state.selectedMonth.month,
			).then((res) => {
				dispatch({ type: type.CHANGE_DETAIL, data: res });
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.selectedMonth]);

	return (
		<div className="flex flex-col md:flex-row w-full h-full p-2">
			<Info />
			<Detail />
		</div>
	);
};

export default Home;
